import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatCurrency } from '../../../utils/localization';

const StatsOverview = ({ stats }) => {
  const statItems = [
    {
      label: 'Total Events',
      value: stats?.totalEvents,
      icon: 'Calendar',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: stats?.eventsChange,
      changeType: stats?.eventsChange > 0 ? 'increase' : 'decrease'
    },
    {
      label: 'Total Expenses',
      value: formatCurrency(stats?.totalExpenses),
      icon: 'DollarSign',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: stats?.expensesChange,
      changeType: stats?.expensesChange > 0 ? 'increase' : 'decrease'
    },
    {
      label: 'You Owe',
      value: formatCurrency(stats?.totalOwed),
      icon: 'TrendingDown',
      color: 'text-error',
      bgColor: 'bg-error/10',
      change: stats?.owedChange,
      changeType: stats?.owedChange > 0 ? 'increase' : 'decrease'
    },
    {
      label: 'Owed to You',
      value: formatCurrency(stats?.totalOwedToYou),
      icon: 'TrendingUp',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: stats?.owedToYouChange,
      changeType: stats?.owedToYouChange > 0 ? 'increase' : 'decrease'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statItems?.map((item, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 transition-all duration-200 hover:shadow-subtle">
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-lg ${item?.bgColor}`}>
              <Icon name={item?.icon} size={20} className={item?.color} />
            </div>
            {item?.change !== undefined && (
              <div className={`flex items-center space-x-1 text-xs ${
                item?.changeType === 'increase' ? 'text-success' : 'text-error'
              }`}>
                <Icon 
                  name={item?.changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'} 
                  size={12} 
                />
                <span>{Math.abs(item?.change)}%</span>
              </div>
            )}
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">
              {item?.value}
            </h3>
            <p className="text-sm text-muted-foreground">
              {item?.label}
            </p>
          </div>

          {item?.change !== undefined && (
            <div className="mt-3 pt-3 border-t border-border">
              <p className="text-xs text-muted-foreground">
                {item?.changeType === 'increase' ? 'Increased' : 'Decreased'} by{' '}
                <span className={item?.changeType === 'increase' ? 'text-success' : 'text-error'}>
                  {Math.abs(item?.change)}%
                </span>{' '}
                from last month
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;
